import { ZOOM_MAP } from './const.js'
import { getParameterByName, diffDates } from './module/module.js'
import { getPricesFromStorage } from './model/room-load.js'
import { roomsList } from './module/rooms-list.js'
import { map, fillPoint, geoObjects } from './map.js'
import { placemarks } from "./model/placemarks.js";

export const selector = document.getElementById('tl-hotel-select');

export function tabsBookingForm() {

    let listElement = document.querySelectorAll('.bookmarks li[id ^="hotel-"]');

    const changeURL = (value) => {
        var hotel_id = "hotel_id";
        var regex = new RegExp(/hotel_id=[A-Za-z0-9_-]+/g);
        var getParams = window.location.search;
        var params_str = hotel_id + "=" + value;
        var path = "";
        if (getParams.indexOf(hotel_id) != -1) {
            path = getParams.replace(regex, params_str);
        } else {
            if (getParams == "") {
                path = getParams + '?' + params_str;
            } else {
                path = getParams + '&' + params_str;
            }
        }
        window.history.pushState(false, false, path);
    }

    listElement.forEach(function (elem) {
        let prov = getParameterByName('hotel_id');
        let el = elem.getAttribute('id');

        if (document.getElementById(el).getAttribute('data-id') === prov) {
            document.getElementById(el).classList.add('active');

         /*   selector.value = prov;
            fireEvent(selector[0], 'change')*/
            bookingForm(prov);

        } else {
            document.getElementById(el).classList.remove('active');
        }

        if ((prov === 0) || (prov === '0') || (prov == null) || (prov === '')) {
            document.getElementById("hotel-1").classList.add('active');
        }

    });

    let placeMarksRoster = placemarks();


    listElement.forEach(function (elem) {
        elem.addEventListener("click", function () {
            let listActiveElement = document.querySelector('.bookmarks li.active'),
                data_id = document.getElementById(elem.getAttribute('id')).getAttribute('data-id');




            listActiveElement.classList.remove('active');
            document.getElementById(elem.getAttribute('id')).classList.add('active');

            // changeURL(data_id);
             bookingForm(data_id);

            fillPoint(placemarks());

            placeMarksRoster.forEach((item, i) => {
                let coords = geoObjects[i].geometry.getCoordinates();
                map.setCenter(coords, ZOOM_MAP, {duration: 300})
            })



        });
    });


}

export function changeURLDate(param, regex, value) {
    var getParams = window.location.search;
    var params_str = param + "=" + value;
    var path = "";
    if (getParams.indexOf(param) != -1) {
        path = getParams.replace(regex, params_str);
    } else {
        if (getParams == "") {
            path = getParams + '?' + params_str;
        } else {
            path = getParams + '&' + params_str;
        }
    }
    window.history.pushState(false, false, path);
}

export function setQueryParam(param, value) {
    var url = new URL(window.location);
    var urlParams = new URLSearchParams(url.search);

    urlParams.set(param, value);
    url.search = urlParams.toString();

    window.history.pushState({}, '', url);
}


export function fireEvent(element, event) {
    if (document.createEventObject) {
        var ieEvt = document.createEventObject();
        return element.fireEvent('on' + event, ieEvt);
    }
    else {
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent(event, true, true);
        return !element.dispatchEvent(evt);
    }
}




function trackUserAction(data) {
    let roomList = null;
    let roomsFb;

    if (data.action === 'search-rooms') {
        roomsFb = data.rooms;
        roomList = getPricesFromStorage();

        if (getParameterByName('date'))    {
            let arrival = data.arrival;
            let departure = data.departure;
            let nights = diffDates(new Date(departure),  new Date(arrival));

            let date = "date";
            let regexDate = new RegExp(/date=[A-Za-z0-9_-]+/g);
            changeURLDate(date, regexDate, arrival)

            let nightsUrl = "nights";
            let regexNights = new RegExp(/nights=\d+/g);
            changeURLDate(nightsUrl, regexNights, nights)
        }

        roomsList(roomsFb, roomList);

    }

}
function noAvailableRooms(data) {
    let roomsFb = data.rooms;
    let roomList = getPricesFromStorage();
    roomsList(roomsFb, roomList);
}

export function bookingForm(roomTypes) {
    (function (w) {
        var q = [
            ['setContext', 'TL-INT-flathome24', `${MAP_BOOKING_LANG}`],
            ['embed', 'booking-form', {
                container: 'tl-booking-form',
                roomType: roomTypes,
                autoScroll: 'none',
                onTrackUserAction: trackUserAction,
                onNoAvailableRooms: noAvailableRooms
            }]
        ];
        var h=["ru-ibe.tlintegration.ru","ibe.tlintegration.ru","ibe.tlintegration.com"];
        var t = w.travelline = (w.travelline || {}),
            ti = t.integration = (t.integration || {});
        ti.__cq = ti.__cq? ti.__cq.concat(q) : q;
        if (!ti.__loader) {
            ti.__loader = true;
            var d=w.document,c=d.getElementsByTagName("head")[0]||d.getElementsByTagName("body")[0];
            function e(s,f) {return function() {w.TL||(c.removeChild(s),f())}}
            (function l(h) {
                if (0===h.length) return; var s=d.createElement("script");
                s.type="text/javascript";s.async=!0;s.src="https://"+h[0]+"/integration/loader.js";
                s.onerror=s.onload=e(s,function(){l(h.slice(1,h.length))});c.appendChild(s)
            })(h);
        }
    })(window);

}

